import { Button, ClassName, Form, IFormRender } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import CertificationPickerFormField from 'components/domain/certification/CertificationPickerFormField/CertificationPickerFormField';
import { t } from 'i18next';
import { isNil } from 'lodash';
import { useRef } from 'react';
import v_existing_certification from 'utils/validations/v_existing_certification';
import v_require from 'utils/validations/v_require';

export interface ICertificationLinkFormProps {
  onDelete: () => void;
  onSubmit: (data: ICertificationLinkFormData) => void;
  existingCertificationIds?: string[];
  certificationId?: string;
  className?: ClassName;
}

export interface ICertificationLinkFormData {
  certificationId?: string;
}

const CertificationLinkForm = (props: ICertificationLinkFormProps) => {
  const { onDelete, onSubmit, existingCertificationIds, certificationId, className } = props;

  const formData = useRef<ICertificationLinkFormData>({
    certificationId,
  });

  const renderFormFields = ({ ...form }: IFormRender<ICertificationLinkFormData>) => {
    const isLinked =
      !isNil(form.state.data.certificationId) && existingCertificationIds?.includes(form.state.data.certificationId);

    return (
      <>
        <CertificationPickerFormField
          form={form}
          name="certificationId"
          validations={[{ validation: v_require }, { validation: v_existing_certification, args: { isLinked } }]}
          allowManage={true}
        />
        <Button type="primary" onClick={form.handleSubmit} className="m-2">
          {t('Submit')}
        </Button>
        {!isNil(certificationId) && (
          <div className={'delete-button mx-2'} onClick={onDelete}>
            {t('Delete')}
          </div>
        )}
      </>
    );
  };

  const classes = classNames('certification-link-form', className);

  return <Form className={classes} data={formData.current} onSubmit={onSubmit} render={renderFormFields} />;
};

export default CertificationLinkForm;
